import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      window.renderAllChildReactOnRailsComponents(this.element);
    }, 500)
  }
}
